export const OPEN_ERROR_ALERT = 'OPEN_ERROR_ALERT'
export const ADD_ONLY_ERRORS = 'ADD_ONLY_ERRORS'
export const CLOSE_ERROR_ALERT = 'CLOSE_ERROR_ALERT'